import React from 'react'; 
import ScrollAnimation from 'react-animate-on-scroll';
import WithConsumer from '../context/WithConsumer';
import ArticleImage from './ArticleImage';
import ArticleText from './ArticleText';
import ArticleGallery from './ArticleGallery';
import ArticleThumb from './ArticleThumb';
import Foot from './Foot';

const Article = ({ context }) => {

	let results = '';
		 
    const posts = () => context.posts;
    const post = posts()[0];
	
	const ctxPageLoaded = () => context.pageLoaded;
    const pageLoaded = ctxPageLoaded();
    
    const ctxDoRender = () => context.doRender;
    const doRender = ctxDoRender();
    
    let pageClass = 'c-page-wrapper state-not-loaded';
    if (pageLoaded == true) {
	    pageClass = 'c-page-wrapper state-loaded';
    }
   
    if (post && doRender) {
	    
		let thumbs = null;
	    if (post.thumb) {
		    thumbs = post.thumb.map((thumb,i) =>
			    <ArticleThumb thumb={thumb} key={i}></ArticleThumb>
			);
	    }
    
    	results = (
	    	<div className={pageClass}>
	    		<article className="c-article">
			    	<div className="l-grid">
			    		<div className="l-grid__col l-grid__col l-grid__col--m-5-12">
		    				<header className="c-article__header">
		    					<h1 className="c-heading c-heading--large" dangerouslySetInnerHTML={ {__html: post.heading } }></h1>
							</header>
			    		</div>
			    		<div className="l-grid__col l-grid__col l-grid__col--m-6-12 l-grid__col--m-push-1-12">
			    			<ArticleImage post={post}></ArticleImage>
			    		</div>
			    	</div>
			    	<div className="l-grid l-grid--m-reverse">
			    		<div className="l-grid__col l-grid__col l-grid__col--m-6-12">
			    			<ArticleText post={post}></ArticleText>
			    		</div>
			    		<div className="l-grid__col l-grid__col l-grid__col--m-6-12">
			    			<ArticleGallery post={post}></ArticleGallery>
			    		</div>
			    	</div>
			    	{thumbs &&
				    	<div className="l-grid">
				    		<div className="l-grid__col">
				    			<h2 className="c-article__related-heading">More articles</h2>
				    			<div className="c-articles c-articles--more">
				    				{ thumbs }
				    			</div>
				    		</div>
				    	</div>
			    	}
		    	</article>
		    	<Foot></Foot>
			</div>
		);
		
	} else {
		
		results = null;
	}
	return (results);
};
export default WithConsumer(Article);